import factory from '../requestFactory';
import store from '@/store'

export default (payload) => {
    let params = {
        service_type: payload.serviceTypes,
        booking_status: payload.bookingStatus,
        patient_id: store.getters.patient.id
    }
    return factory()
        .get('/patient/visits', {params:params})

};
